exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-area[data-v-645750f7] {\n    position: relative;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n    max-height: 290px;\n}\n", ""]);

// exports
